import * as React from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'primaryOutlined' | 'secondaryOutlined';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  loadingText?: string;
  variant?: ButtonVariant;
};

const variantClasses: Record<ButtonVariant, string> = {
  primary: 'bg-primary hover:bg-primary-hover text-white',
  secondary: 'bg-secondary hover:bg-secondary-hover text-white',
  primaryOutlined: 'bg-transparent border-2 border-green-600 text-green-600 hover:bg-green-50',
  secondaryOutlined: 'bg-transparent border-2 border-secondary text-secondary hover:text-secondary-hover',
};

const Button: React.FC<ButtonProps> = ({
  loading = false,
  disabled = false,
  children,
  loadingText = 'Loading...',
  variant = 'primary',
  className, // explicitly extract className
  ...props
}) => {
  return (
    <button
      className={[
        variantClasses[variant],
        'font-semibold text-lg px-4 py-2 rounded-md cursor-pointer',
        className, // append user classes last so they can override
      ]
        .filter(Boolean)
        .join(' ')}
      disabled={loading || disabled}
      {...props}
      style={{
        opacity: loading || disabled ? 0.6 : 1,
        pointerEvents: loading || disabled ? 'none' : 'auto',
        ...props.style,
      }}
    >
      {loading ? loadingText : children}
    </button>
  );
};

export default Button;
